<template>
  <jczh-drawer
    :visible.sync="visible"
    title="取消部分采购"
    size="70%"
    :el-attrs="{
      destroyOnClose: true
    }"
    @close="closeDrawer"
    @confirm="onConfirm"
  >
    <template v-slot:content>
      <div class="p-t-24">
        <flow-item-sheet-wuling
          v-if="isTableGreyFeatures"
          :reason-form.sync="cancelReasonForm"
          :table-data="cancelItemList"
          :is-dollar="isDollar"
          @cancelFlow="cancelFlow"
        />
        <flow-item-sheet
          v-else
          :reason-form.sync="cancelReasonForm"
          :table-data="cancelItemList"
          :item-schema-list="itemSchemaList"
          :is-dollar="isDollar"
          @cancelFlow="cancelFlow"
        />
      </div>
    </template>
  </jczh-drawer>
</template>

<script>
import FlowItemSheetWuling from '@/components/inquiry/FlowItemSheetWuling.vue'
import FlowItemSheet from '@/components/inquiry/FlowItemSheet.vue'
import { cloneDeep, unionBy } from 'lodash'

/**
 * 单项流标侧边抽屉
 */
export default {
  name: 'FlowItemSheetDrawer',

  components: { FlowItemSheet, FlowItemSheetWuling },

  props: {
    itemSchemaList: {
      type: Array,
      default: () => []
    },

    isDollar: {
      type: Boolean,
      default: false
    },

    isTableGreyFeatures: {
      type: Boolean,
      default: false
    },

    cancelItemList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      visible: false,

      cancelReasonForm: {
        cancelReason: null,
        cancelAttachmentIds: []
      }
    }
  },

  methods: {
    openDrawer() {
      this.visible = true
    },

    closeDrawer() {
      this.visible = false
    },

    onConfirm() {
      if (!this.cancelItemList?.length) {
        this.$confirm('请重新选择需要取消的品目')
          .then(() => {
            this.closeDrawer()
          })
          .catch(() => {})
        return
      }
      this.$confirm('该操作确定后不可取消', '系统提示')
        .then(() => {
          const cancelData = {
            cancelItemList: unionBy(
              this.cancelItemList.map(value => {
                return {
                  materielId: value.materielId,
                  supplierNum: Object.keys(value.offerValue || {}).filter(
                    key => {
                      return value.offerValue[key]?.tradeId
                    }
                  ).length
                }
              }),
              'materielId'
            ),
            ...this.cancelReasonForm
          }
          this.$emit('confirmFlow', cancelData)
          this.closeDrawer()
        })
        .catch(() => {})
    },

    // 将取消的采购品目退回授标
    cancelFlow(rowData) {
      this.$confirm('是否将该品目退回授标', '系统提示', {
        type: 'warning'
      })
        .then(() => {
          this.$emit('cancelFlowItem', rowData)
        })
        .catch(() => {
          //
        })
    }
  }
}
</script>

<style scoped lang="scss"></style>
